import AMapLoader from '@amap/amap-jsapi-loader'
import { A_MAP_KEY, A_MAP_CODE } from '@/config/public.config'

class AMap {
  amapExample;

  constructor() {
    window._AMapSecurityConfig = {
      securityJsCode: A_MAP_CODE,
    }
  }

  async #_initAMap(plugins) {
    try {
      this.amapExample = await AMapLoader.load({
        key: A_MAP_KEY,
        version: '2.0',
        plugins,
      });
    } catch (error) {
      console.error('AMap 加载失败:', error);
    }
  }

  async getAMap(plugins) {
    if (!this.amapExample) {
      await this.#_initAMap(plugins);
    }
    return this.amapExample;
  }

  /** 获取当前定位 */
  async getCurrentLocation() {
    if (!this.amapExample) {
      await this.#_initAMap(['Geolocation']);
    }
    return new Promise((resolve, reject) => {
      this.amapExample.plugin('AMap.Geolocation', () => {
        const geolocation = new this.amapExample.Geolocation({
          enableHighAccuracy: true,
          timeout: 20000,
        });
        geolocation.getCurrentPosition((status, result) => {
          if (status === 'complete') {
            resolve(result);
          } else {
            console.log(status, result)
            reject(new Error('获取位置失败'));
          }
        });
      });
    });
  }

}

export default AMap;